"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMobile = void 0;
const react_1 = require("react");
const getIsMobile = () => {
    const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    return isMobileDevice || window.innerWidth <= 768;
};
const useIsMobile = () => {
    const [isMobile, setIsMobile] = (0, react_1.useState)(getIsMobile);
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            setIsMobile(getIsMobile());
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return isMobile;
};
exports.useIsMobile = useIsMobile;
